import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

export function useReservationSubsidyEnabled(): boolean {
  const flagsQuery = usePublicFeatureFlags()
  const reservation = flagsQuery.data?.find((row) => row.module_name === 'reservation')
  const raw = reservation?.metadata?.subsidy_enabled

  if (typeof raw === 'boolean') {
    return raw
  }

  return true
}
